<!-- Custom header with HTML support and close button -->
@if (dialogConfig.data?.headerHtml) {
    <div class="dialog-heading">
        <h2 class="section-title m-0" [innerHTML]="dialogConfig.data.headerHtml"></h2>
        <p-button
            icon="ms ms-close"
            severity="secondary"
            [text]="true"
            [rounded]="true"
            [ariaLabel]="'common.close_button' | translate"
            (onClick)="onCancel()" />
    </div>
}

<form #moveCopyForm="ngForm" class="form-grid" (ngSubmit)="onSubmit()">
    <!-- Shared: year drives the entity list in both modes. -->
    <div class="form-field">
        <label for="move-copy-year" class="form-field__label form-field__label--required">{{
            'advancedMeasure.groupActions.form.label.year' | translate
        }}</label>
        <p-select
            inputId="move-copy-year"
            name="year"
            required
            #yearModel="ngModel"
            [options]="availableYears"
            [(ngModel)]="selectedYear"
            [placeholder]="'results.selectMeasure.inputs.periods.placeholder' | translate"
            appendTo="body" />
        @if (yearModel.invalid && yearModel.touched) {
            <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
        }
    </div>

    <!-- Move mode: single destination entity (filtered by year). -->
    @if (mode === 'move') {
        <div class="form-field">
            <label for="move-copy-entity" class="form-field__label form-field__label--required">{{
                'results.selectMeasure.inputs.entity.label' | translate
            }}</label>
            <p-select
                inputId="move-copy-entity"
                name="entity"
                required
                #entityModel="ngModel"
                [options]="filteredEntities"
                [(ngModel)]="selectedEntity"
                optionLabel="name"
                [placeholder]="'results.selectMeasure.inputs.entity.placeholder' | translate"
                [disabled]="selectedYear === null"
                appendTo="body" />
            @if (entityModel.invalid && entityModel.touched) {
                <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
            }
        </div>
    }

    <!-- Copy mode: multi destination entities (filtered by year). -->
    @if (mode === 'copy') {
        <div class="form-field">
            <label for="move-copy-destinations" class="form-field__label form-field__label--required">{{
                'advancedMeasure.groupActions.form.label.destinationEntities' | translate
            }}</label>
            <p-multiSelect
                inputId="move-copy-destinations"
                name="destinationEntities"
                required
                #destinationsModel="ngModel"
                [options]="filteredEntities"
                [(ngModel)]="selectedEntities"
                optionLabel="name"
                display="chip"
                [placeholder]="'results.selectMeasure.inputs.entity.placeholder' | translate"
                [disabled]="selectedYear === null"
                appendTo="body"
                [filterPlaceHolder]="'common.search' | translate">
                <!-- Every destination as a chip, on as many lines as needed. -->
                <ng-template let-items pTemplate="selectedItems">
                    @if (items?.length) {
                        <span class="destination-chips">
                            @for (item of items; track item) {
                                <p-chip>
                                    <span class="chip-label">{{ item.name }}</span>
                                </p-chip>
                            }
                        </span>
                    }
                </ng-template>
            </p-multiSelect>
            @if (destinationsModel.invalid && destinationsModel.touched) {
                <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
            }
        </div>
    }

    <div class="form-actions">
        <p-button severity="secondary" [label]="'common.cancel_button' | translate" (onClick)="onCancel()" />
        <p-button type="submit" [label]="'common.confirm_button' | translate" />
    </div>
</form>
